export const ROUTES = {
    marketReport: '/market-data/market-report/stock/:symbol'
};
